import i18next from 'i18next';

i18next.addResources('es_CL', 'CustomModal', {
  closeButton: 'Botón cerrar'
});

i18next.addResources('pt_PT', 'Cart', {
  closeButton: 'Botão Fechar'
});
